import Model from '../Model';
import Mithril from 'mithril';

export default class PkgLogo extends Model {
  ids() {
    return Model.attribute<number>('id').call(this);
  }
  createTime() {
    return Model.attribute('createTime', Model.transformDate).call(this);
  }
  pkgName() {
    return Model.attribute<string>('pkgName').call(this);
  }
  pkgLogo() {
    return Model.attribute<string>('pkgLogo').call(this);
  }
  pkgIcon() {
    return Model.attribute<string>('pkgIcon').call(this);
  }
  pkgStr() {
    return Model.attribute<string>('pkgStr').call(this);
  }
  lessFile() {
    return Model.attribute<string>('lessFile').call(this);
  }
  cdnUrl() {
    return Model.attribute<string>('cdnUrl').call(this);
  }
  ossFile() {
    return Model.attribute<string>('ossFile').call(this);
  }
  status() {
    return Model.attribute<number>('status').call(this);
  }
  ruleLink() {
    return Model.attribute<string>('ruleLink').call(this);
  }
  userLink() {
    return Model.attribute<string>('userLink').call(this);
  }
  domain() {
    return Model.attribute<string>('domain').call(this);
  }
  appId() {
    return Model.attribute<string>('appId').call(this);
  }
  entranceId() {
    return Model.attribute<string>('entranceId').call(this);
  }
  defaultPkgIds() {
    return Model.attribute<string>('defaultPkgIds').call(this);
  }
  postButtonPrompt() {
    return Model.attribute<string>('postButtonPrompt').call(this);
  }
  pkgImage() {
    return Model.attribute<string>('pkgImage').call(this);
  }
  chatImage() {
    return Model.attribute<string>('chatImage').call(this);
  }
  chatStatus() {
    return Model.attribute<number>('chatStatus').call(this);
  }

  /**
   * Update the user's preferences.
   */
  // savePreferences(newPreferences: Record<string, unknown>): Promise<this> {
  //   const preferences = this.preferences();

  //   Object.assign(preferences ?? {}, newPreferences);

  //   return this.save({ preferences });
  // }
}
